import React, { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import InputPaymentInfoModal from '../PackageUpgrade/InputPaymentInfoModal';
import { splitPriceByThree } from '../../../utils';
import styles from './ConversationCharge.module.scss';
import { PrimaryInfoIcon } from '../../../assets/icons';
import {
  setIsOfficialBillNeeded,
  setSelectedConversationCount,
} from '../../../redux/payments/payments.actions';
import { HeaderSectionIcon } from '../..';
import useTranslation from 'hooks/useTranslation';
import { replaceKeyWithValue } from 'utils/text';
import DashboardSectionHeader from 'layouts/Dashboard/DashboardSectionHeader';
import DashboardMainSectionWrapper from 'layouts/Dashboard/DashboardMainSectionWrapper';
import { ReactComponent as DownloadIcon } from 'assets/icons/download-icon.svg';
import { getArrayOfInfoBasedOnUserType } from 'redux/payments/payments.adapter';
import { UserInfoModal } from 'components';
import { useModal } from 'hooks';
import clsx from 'clsx';

const mapState = (state) => ({
  isOfficialBillNeeded: state.paymentsData.isOfficialBillNeeded,
  selectedConversationCount: state.paymentsData.selectedConversationCount,
  baseConversationPriceObj: state.paymentsData.baseConversationPrice,
  invoiceId: state.paymentsData.invoiceId,
  locale: state.appData.locale,
  paymentInfo: state.paymentsData.paymentInfo,
});
const getProfile = ({ userData }) => userData.profile;

const ConversationCharge = (props) => {
  const {
    isOfficialBillNeeded,
    selectedConversationCount,
    baseConversationPriceObj,
    locale,
    paymentInfo,
  } = useSelector(mapState);
  const profile = useSelector(getProfile);
  const baseConversationPrice = baseConversationPriceObj[locale];

  const dispatch = useDispatch();
  const price = selectedConversationCount * baseConversationPrice;
  const tax = locale === 'fa' ? price * 0.1 : 0;
  // post price is just for persian locale
  const postPrice = isOfficialBillNeeded && locale === 'fa' ? 75000 : 0;
  const totalPrice = price + tax + postPrice;
  const { getTranslation } = useTranslation('CONVERSATION_CHARGE');
  const { t } = getTranslation();
  const [isUserInfoModalVisible, , hideUserInfoModal, showUserInfoModal] =
    useModal();

  const handleSliderChange = (value) => {
    dispatch(setSelectedConversationCount(value));
  };

  const handleSetIsOfficialBillNeeded = (event) => {
    dispatch(setIsOfficialBillNeeded(event.target.checked));
  };

  // TODO: there is similar section in upgrade page, consider extracting component out of it
  const renderSelectDeliveryType = locale === 'fa' && (
    <div className={styles.selectDeliveryType}>
      {/* <input
        type='checkbox'
        id='isOfficialBillNeeded'
        onChange={handleSetIsOfficialBillNeeded}
        checked={isOfficialBillNeeded}
      />
      <label htmlFor='isOfficialBillNeeded' aria-describedby='label'>
        {t('SEND_OFFICIAL_INVOICE')}
      </label> */}
      <div className={styles.selectDeliveryType__subtext}>
        <DownloadIcon className={styles.selectDeliveryType__subtext__icon} />
        <div>
          <span>دانلود فاکتور رسمی: تمدید یا ارتقای پکیج </span>
          {' > '}
          <Link to='/payment/bills'>لیست صورتحساب‌ها</Link>
        </div>
      </div>
    </div>
  );

  // const renderPostingRow = locale === 'fa' && (
  //   <div className={styles.priceWrapper}>
  //     <span>{t('POSTING')}:</span>
  //     <strong>
  //       {splitPriceByThree(postPrice)} {t('UNIT')}
  //     </strong>
  //   </div>
  // );

  useEffect(() => {
    handleSetIsOfficialBillNeeded({ target: { checked: false } });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locale]);

  const renderHeader = (
    <DashboardSectionHeader>
      <header
        className={clsx(styles.conversationChargeHeader, 'flex flex-colgap-8')}
      >
        <HeaderSectionIcon />

        <div>
          <h1 className={clsx(styles.h1, 'main_section_header_title')}>
            {t('HEADING_TITLE')}
          </h1>
          <p className={clsx(styles.description, 'main_section_header_desc')}>
            {t('HEADING_SUBTITLE')}
          </p>
        </div>
      </header>
    </DashboardSectionHeader>
  );

  // TODO: extract component out of it, have similar in upgrade page
  const renderDataBox = () => {
    const infoData = paymentInfo.data;
    const anyInfoData = infoData && Object.keys(infoData).length !== 0;

    if (!anyInfoData) return null;

    const formData = getArrayOfInfoBasedOnUserType({
      ...infoData,
      mobileNumber: profile.mobile,
      mobile: profile.mobile,
    });

    const dataBox = formData?.map(
      (item, index) =>
        item && (
          <div key={index} className={styles.databox__item}>
            <span>{item.label} : </span>
            <b className={styles.user_info__value}>{item.value}</b>
          </div>
        )
    );

    return (
      <div className={styles.info_review__wrapper}>
        <div className={styles.info_review}>
          <div className='flex flex-column'>
            <h2>اطلاعات</h2>
            <div>
              <div className={styles.databox}>{dataBox}</div>
              <button
                className={clsx(['btn btn-primary', styles.edit_info_btn])}
                onClick={showUserInfoModal}
              >
                {t('INFO_EDIT_BTN')}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      {renderHeader}

      <DashboardMainSectionWrapper>
        <section className={styles.conversationCharge}>
          <h1>{t('CONVERSATIN_COUNT')}</h1>

          <div className={styles.sliderBox}>
            <Slider
              min={500}
              max={5000}
              step={500}
              dots={true}
              marks={{
                500: 500,
                1000: 1000,
                1500: 1500,
                2000: 2000,
                2500: 2500,
                3000: 3000,
                3500: 3500,
                4000: 4000,
                4500: 4500,
                5000: 5000,
              }}
              value={selectedConversationCount}
              onChange={handleSliderChange}
            />
          </div>

          <div className={styles.infoWrapper}>
            <img src={PrimaryInfoIcon} alt='' />
            <span>
              {replaceKeyWithValue(
                t('PRICE_PER_CONV'),
                'price',
                baseConversationPrice
              )}
            </span>
          </div>

          <div className={styles.purchase_details_and_info}>
            <div className={styles.purchase_details}>
              <div className={styles.priceWrapper}>
                <span>{t('CONV_CHARGE')}:</span>
                <strong>
                  {splitPriceByThree(price)} {t('UNIT')}
                </strong>
              </div>
              <div className={styles.priceWrapper}>
                <span>{t('TAX')} :</span>
                <strong>
                  {splitPriceByThree(tax)} {t('UNIT')}
                </strong>
              </div>
              {/* {renderPostingRow} */}
              <div className={styles.totalPriceWrapper}>
                <span>{t('TOTAL')}:</span>
                <strong>
                  {splitPriceByThree(totalPrice)} {t('UNIT')}
                </strong>
              </div>
            </div>
            {renderDataBox()}
          </div>

          {renderSelectDeliveryType}
          <InputPaymentInfoModal isPackageUpgrade={false} />
          <UserInfoModal
            visible={isUserInfoModalVisible}
            handleClose={hideUserInfoModal}
            doAfterSuccessfullUpdate={hideUserInfoModal}
          />
        </section>
      </DashboardMainSectionWrapper>
    </>
  );
};

export default ConversationCharge;
